(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bemp-peptide-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bemp-peptide-stories')) {
  customElements.define('bemp-peptide-stories', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-story-track]');
      this.slides = Array.from(this.querySelectorAll('[data-story-slide]'));
      if (!this.track || this.slides.length < 2 || this.abortController) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.previous = this.querySelector('[data-story-previous]');
      this.next = this.querySelector('[data-story-next]');
      this.dots = Array.from(this.querySelectorAll('[data-story-dot]'));
      this.status = this.querySelector('[data-story-status]');
      this.currentIndex = 0;
      this.querySelector('.bemp-stories__toolbar').hidden = false;
      this.querySelector('.bemp-stories').classList.add('is-ready');
      this.previous.addEventListener('click', () => this.goTo(this.currentIndex - 1), options);
      this.next.addEventListener('click', () => this.goTo(this.currentIndex + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), options));
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const targets = { ArrowLeft: this.currentIndex - 1, ArrowRight: this.currentIndex + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in targets)) return;
        event.preventDefault();
        this.goTo(targets[event.key]);
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const width = this.track.clientWidth;
          if (width) this.select(Math.round(Math.abs(this.track.scrollLeft) / width));
        });
      }, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => this.goTo(this.currentIndex, false));
      this.resizeObserver.observe(this.track);
      this.select(0);
    }
    goTo(index, animate = true) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollTo({ left: target * this.track.clientWidth * (rtl ? -1 : 1), behavior: animate && !reduced ? 'smooth' : 'auto' });
      if (!animate) this.select(target);
    }
    select(index) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === target;
        if (!active && slide.contains(document.activeElement)) this.track.focus({ preventScroll: true });
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === target)));
      this.previous.disabled = target === 0;
      this.next.disabled = target === this.slides.length - 1;
      if (this.currentIndex !== target) this.status.textContent = this.status.dataset.statusTemplate.replace('__NUMBER__', String(target + 1));
      this.currentIndex = target;
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bemp-serum-routine"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bemp-cream-carousel')){customElements.define('bemp-cream-carousel',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.bemp-routine__track');const controls=this.querySelector('.bemp-routine__controls');const buttons=[...this.querySelectorAll('[data-direction]')];if(!track||!controls)return;controls.hidden=false;const update=()=>{buttons[0].disabled=track.scrollLeft<3;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;};buttons.forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('.bemp-routine__card');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:(card.getBoundingClientRect().width+gap)*Number(button.dataset.direction),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));track.addEventListener('scroll',update,{passive:true});this.observer=new ResizeObserver(update);this.observer.observe(track);update();}disconnectedCallback(){this.observer?.disconnect();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
